import React from "react";

const ChevronRight: React.FC<React.SVGProps<SVGSVGElement>> = ({ width = 8, height = 12, ...props }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 8 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
			{...props}
		>
			<path
				d="M1.5 1L6.5 6L1.5 11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default ChevronRight;
